import React from "react";
import PropTypes from "prop-types";
import {Link} from 'react-router-dom/';

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import {Parts} from "../index";
import Select from "react-select";
import {Modal, ModalBody} from "reactstrap";
import FreshdeskTicketLink from "utils/FreshdeskTicketLink";
import {freshdeskTicketExport} from "utils/freshdeskTicket";
import IconButton from "@material-ui/core/IconButton";
import LeftArrowIcon from "@material-ui/icons/ChevronLeft";
import RightArrowIcon from "@material-ui/icons/ChevronRight";

const COL_WIDTH = 150;

const SCORE_COLUMNS = [
	{
		Header: "Engineer",
		accessor: "engineer",
		width: COL_WIDTH
	},
	{
		Header: "FD Ticket",
		id: "fresh_ticket",
		width: COL_WIDTH,
		accessor: (obj) => freshdeskTicketExport(obj.fresh_ticket),
		Cell: props => <FreshdeskTicketLink freshTicket={props.original.fresh_ticket} />
	},
	{
		Header: "Total Score",
		accessor: "total_score",
		width: COL_WIDTH
	},
	{
		Header: "Labor Amount",
		id: "financials",
		accessor: (obj) => obj.financial,
		width: COL_WIDTH,
		Cell: props => <span>{props.original.financial ? `$${props.original.financial}` : 0}</span>
	},
	{
		Header: "TOS (Hours)",
		id: "time_value",
		accessor: (obj) => obj.time_value,
		width: COL_WIDTH,
		Cell: props => <span>{props.original.time_value ? (Math.round(((props.original.time_value / 60) + Number.EPSILON) * 100) / 100) : 0}</span>
	},
	{
		Header: "Backup Score",
		accessor: "backup_score",
		width: COL_WIDTH
	},
	{
		Header: "AV Score",
		accessor: "av_score",
		width: COL_WIDTH
	},
	{
		Header: "Network Score",
		accessor: "network_score",
		width: COL_WIDTH
	},
	{
		Header: "HDD Score",
		accessor: "hdd_score",
		width: COL_WIDTH
	},
	{
		Header: "Notes Score",
		accessor: "notes_score",
		width: COL_WIDTH
	},
	{
		Header: "Time Score",
		accessor: "time_score",
		width: COL_WIDTH
	},
	{
		Header: "Backup Chars",
		accessor: "backup_chars",
		width: COL_WIDTH
	},
	{
		Header: "Backup Images",
		accessor: "backup_images",
		width: COL_WIDTH
	},
	{
		Header: "AV Chars",
		accessor: "av_chars",
		width: COL_WIDTH
	},
	{
		Header: "AV Images",
		accessor: "av_images",
		width: COL_WIDTH
	},
	{
		Header: "Network Chars",
		accessor: "network_chars",
		width: COL_WIDTH
	},
	{
		Header: "Network Images",
		accessor: "network_images",
		width: COL_WIDTH
	},
	{
		Header: "HDD Chars",
		accessor: "hdd_chars",
		width: COL_WIDTH
	},
	{
		Header: "HDD Images",
		accessor: "hdd_images",
		width: COL_WIDTH
	},
	{
		Header: "Notes Chars",
		accessor: "notes_chars",
		width: COL_WIDTH
	},
	{
		Header: "Notes Images",
		accessor: "notes_images",
		width: COL_WIDTH
	},
	{
		Header: "FD Score",
		accessor: "generic_score",
		width: COL_WIDTH
	},
	{
		Header: "FD Chars",
		accessor: "generic_chars",
		width: COL_WIDTH
	},
	{
		Header: "FD Images",
		accessor: "generic_images",
		width: COL_WIDTH
	},
	{
		Header: "Tasks Score",
		accessor: "tasks_score",
		width: COL_WIDTH
	},
	{
		Header: "Tasks Amount",
		accessor: "tasks_amount",
		width: COL_WIDTH
	},
	{
		Header: "Tasks Desc Chars",
		accessor: "tasks_desc_chars",
		width: COL_WIDTH
	},
	{
		Header: "Tasks Comp Chars",
		accessor: "tasks_comp_chars",
		width: COL_WIDTH
	},
];

const EXPANDER_DEFAULTS = {
	sortable: true,
	resizable: true,
	filterable: false,
	width: undefined
};

const selectedUserKey = (users) => (users || []).map((user) => user.value).join(",");

export default class EngineerScores extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Engineer_Scores._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state = {
			...this.state,
			users: [],
			scores: [],
			showDate: false,
			filterDate: moment().format('YYYY-MM-DD'),
			selectedUsers: []
		}
		this.defaultSorted = [
			{
				id: this.model.sort || 'created',
				desc: this.model.order !== 'asc'
			}
		];
	}

	async componentDidMount() {
		super.componentDidMount();
		await this.getUsers();
	}

	componentDidUpdate() {
		// Collection remounts the table (new state.key) when state.filter is a new object.
		// This page owns date/user filters and must not inherit that remount → onFetchData loop.
	}

	componentWillUnmount() {
		if (this._fetchTimer) {
			clearTimeout(this._fetchTimer);
			this._fetchTimer = null;
		}
	}

	fetchData = async (state) => {
		if (typeof (this.state.filter) === "undefined" || Array.isArray(this.state.filter)) {
			this.state.filter = {};
		}
		this.state.filter.day = this.state.filterDate;
		this.state.filter.users = (this.state.selectedUsers || []).map((user) => user.value);
		this.model.filter = this.state.filter;
		this.setState({loading: true});
		if (this._fetchTimer) {
			clearTimeout(this._fetchTimer);
		}
		this._fetchTimer = window.setTimeout(() => {
			this._fetchTimer = null;
			this.fetchDataActual(state, ['formula', 'formula_notes']);
		}, 100);
	}

	getUsers = async () => {
		let userModel = new API.BuildClass(Types.Users._name, API.RequestType.READ);
		this.read = 'GET_FIELD_ENGINEERS';
		let usersPkeys = this.state.selectedUsers.map((user) => user.value);
		try {
			this.users = await userModel.submit(null, this.read);
			this.users = Object.keys(this.users).map((key) => this.users[key]);
			this.users = this.users[3];
			//let selected = this.users.filter(item => usersPkeys.includes(item.pkey));what was this for?

			this.setState({
				users: this.users
			});

		} catch (error) {
			console.log(error, 'error')
		}
	}

	handleToggleModal = (modal) => {
		this.setState({[modal]: !this.state[modal]})
	}

	handleDateChange = async (name, date) => {
		const next = moment(date).format('YYYY-MM-DD');
		if (moment(this.state.filterDate).format('YYYY-MM-DD') === next) {
			this.setState({showDate: false});
			return;
		}
		this.setState({filterDate: next, showDate: false}, () => {
			this.fetchData();
		});
	}

	handleUsers = (value) => {
		const selectedUsers = value ? [...value] : [];
		if (selectedUserKey(selectedUsers) === selectedUserKey(this.state.selectedUsers)) {
			return;
		}
		this.setState({selectedUsers}, () => {
			this.fetchData();
		});
	}


	render() {
		const {data, pages, loading} = this.state;
		const pageSize = Math.max((data && data.length) || 0, 1);
		return (
			<Card>
				<CardContent>
					<div className={"table-bar"}>
						<div className={"row"}>
							<div className={"col-3"} style={{zIndex: 100}}>
								<Select
									placeholder={"User Select"}
									isMulti
									isClearable
									value={this.state.selectedUsers}
									onChange={this.handleUsers}
									options={this.state.users.map(user => ({
										value: user.pkey, label: user.name_first + " " + user.name_last
									}))}
								/>
							</div>
							<div className={'col-9'} style={{display: 'flex', flexDirection: 'column'}}>
								<b>Current Formula: {this.state.formula_notes}</b>
								{this.state.formula?.map((item, index) => <b key={index}>{item}</b>)}
							</div>
						</div>
						<div>
							<Modal
								isOpen={this.state.showDate}
								toggle={this.toggleClose}
								size={"sm"}
								backdrop={true}
								style={{display: "none"}}
							>
								<ModalBody>
									<Framework.Elements.Date
										label={"Custom Date"}
										value={this.state.filterDate}
										update={this.handleDateChange}
										open={this.state.showDate}
										clearable={false}
										cancelLabel={''}
									/>
								</ModalBody>
							</Modal>
							<div className={"row rbc-toolbar"}>
								<div>
									<IconButton onClick={() => {
										this.setState({filterDate: moment(this.state.filterDate).subtract(1, 'day').format('YYYY-MM-DD')}, () => {
											this.fetchData();
										})
									}}><LeftArrowIcon/></IconButton>
									<button className="rbc-today" type="button" onClick={() => {
										this.setState({filterDate: moment().format('YYYY-MM-DD')}, () => {
											this.fetchData();
										})
									}}>Today
									</button>
									<IconButton onClick={() => {
										this.setState({filterDate: moment(this.state.filterDate).add(1, 'day').format('YYYY-MM-DD')}, () => {
											this.fetchData();
										})
									}}><RightArrowIcon/></IconButton>
								</div>
								<div className={"rbc-toolbar-label"}>
									<label onClick={() => {
										this.handleToggleModal('showDate')
									}}>
										{moment(this.state.filterDate).format('dddd MMM D')}
									</label>
								</div>
							</div>
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={SCORE_COLUMNS}
						manual
						data={data}
						pages={pages}
						loading={loading}
						loadingText="Requesting Data"
						onFetchData={this.fetchData}
						expanderDefaults={EXPANDER_DEFAULTS}
						defaultSorted={this.defaultSorted}
						showPagination={true}
						defaultPageSize={pageSize}
						className="-striped -highlight"
						pageSize={pageSize}
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
